export default __webpack_public_path__ + "static/media/company.486c3d42.svg";